import { Box, Text } from "@mantine/core";
import classes from "./index.module.css";

/** Título e descrição: fixos, também no esqueleto. */
export function MediaRetentionHeader() {
  return (
    <Box>
      <Text
        component="h2"
        ff="heading"
        className={classes.title}>
        Arquivos de mídia das conversas
      </Text>
      <Text className={classes.description}>
        Por quanto tempo áudios, imagens, vídeos, documentos e figurinhas ficam
        disponíveis no chat. A transcrição dos áudios e a descrição das imagens
        continuam no histórico da conversa.
      </Text>
    </Box>
  );
}
